import * as React from 'react';
var Pdf = function (_a) {
    var url = _a.url, renderWrap = _a.renderWrap;
    return renderWrap(React.createElement("embed", { src: url, type: "application/pdf", style: { width: '100%', minHeight: 600 }, className: "react-embed--pdf" }));
};
export default Pdf;
//# sourceMappingURL=index.js.map